import * as React from 'react';

import classNames from 'classnames';

import Label from '@/components/Elements/Label/Label';

import './Labels.scss';

export interface Item {
  id: string;
  title: string;
  link?: string;
}

interface Props {
  items: Item[];
  size?: 'large' | 'medium' | 'small';
  title?: string;
  showArrow?: boolean;
}

const Labels = ({ items, size = 'medium', title, showArrow = true }: Props) => (
  <div className={classNames('Labels_container', { 'Labels_container-has-title': title })}>
    {title && <h6 className="subtitle-2 Labels_title">{title}</h6>}
    <ul className="Labels_inner-container">
      {items.map((el) => (
        <Label item={el} size={size} key={el.id} showArrow={showArrow} />
      ))}
    </ul>
  </div>
);

export default Labels;
